import {Reducer} from 'redux';
import {UIActions} from '../UIActions';
import {LocalStatusActionTypes, SetMutationInProgress} from './localStatusActions';

export interface StatusState {
    statuses: {
        [key: string]: {
            date: Date;
            message: string;
        };
    };
    mutationInProgress: boolean;
    unsavedDataAction?: () => void;
    isDirty: boolean;
    isIdle: boolean;
}

export const defaultState: StatusState = {
    statuses: {},
    mutationInProgress: false,
    isDirty: false,
    isIdle: false,
};

export const localStatusReducer: Reducer<StatusState, UIActions> = (state = defaultState, action: UIActions) => {
    switch (action.type) {
        case LocalStatusActionTypes.SET_MUTATION_IN_PROGRESS:
            return {
                ...state,
                mutationInProgress: (action as SetMutationInProgress).payload.open,
            };
        case LocalStatusActionTypes.SET_UNSAVED_DATA_ACTION:
            return {
                ...state,
                unsavedDataAction: action.payload.action,
            };
        case LocalStatusActionTypes.SET_TO_DIRTY: {
            return {
                ...state,
                isDirty: action.payload.setToDirty,
            };
        }
        case LocalStatusActionTypes.SET_TO_IDLE: {
            return {
                ...state,
                isIdle: action.payload.isIdle,
            };
        }
        default:
            return state;
    }
};
